import * as React from 'react'
import {Fragment} from 'react'
import {observer} from 'mobx-react'
import {EpikQueryParam, EpmsPaymentStatus} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {WidgetFlag} from '../../../../lib/WidgetFlag'
import {WidgetView} from '../../../../lib/WidgetView'
import {SubscriptionPaymentMethodUpdated} from '../../common/elements/SubscriptionPaymentMethodUpdated'
import {Faq} from '../../common/elements/Faq'
import {EpmsPaymentInfoStatus} from '../../common/elements/EpmsPaymentInfoStatus'
import {RetryPayment} from '../../common/elements/RetryPayment'
import {FooterInfo} from '../../common/elements/FooterInfo'
import {EpmsSubscriptionInfo} from '../elements/EpmsSubscriptionInfo'
import {EpmsSubscriptionNotFoundBlock} from './EpmsSubscriptionNotFoundBlock'

///////////////////////////////////////////////////////////////////////////////

export const EpmsSubscriptionInfoBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  let finalStatus = null
  let showStatus = false
  let showInfo = false
  let isSuccess = false
  let showSubscriptionPaymentMethodUpdated = false
  const showRetryPaymentButton = api.resolveConfigWithSingleResult<boolean>(
    'showRetryPaymentButton',
  )
  const paymentType = 'epms_subscription'

  if (api.flags.has(WidgetFlag.EPMS_SUBSCRIPTION_NOT_FOUND)) {
    return <EpmsSubscriptionNotFoundBlock />
  }

  if (api.flags.has(WidgetFlag.HAS_EPMS_PAYMENT_INFO)) {
    finalStatus = api.epmsPaymentInfo?.last_status

    isSuccess = [
      EpmsPaymentStatus.SUCCEEDED,
      EpmsPaymentStatus.PENDING,
    ].includes(finalStatus)
    showSubscriptionPaymentMethodUpdated =
      isSuccess &&
      api.currentLocation.params[EpikQueryParam.VIEW] ===
        WidgetView.SUBSCRIPTION_PAYMENT_METHOD_UPDATE_RESULT

    if (isSuccess) {
      showStatus =
        api.currentLocation.params[EpikQueryParam.VIEW] ===
        WidgetView.PAYMENT_RESULT
      showInfo = true
    } else {
      showStatus = true
    }
  } else {
    showInfo = true
  }

  return (
    <div className="widget-block epms-subscription-info-block">
      {isSuccess && !showStatus && (
        <div className="widget-block-header">
          <div className="title">
            <h2 className="text">
              {api.trans('blocks.epms_subscription_info.title')}
            </h2>
          </div>
        </div>
      )}

      <div className="widget-block-content">
        {showSubscriptionPaymentMethodUpdated && (
          <SubscriptionPaymentMethodUpdated />
        )}
        {showStatus && (
          <EpmsPaymentInfoStatus
            paymentType={paymentType}
            finalStatus={finalStatus}
          />
        )}

        {showInfo && (
          <Fragment>
            <EpmsSubscriptionInfo />
            <Faq />
            {showRetryPaymentButton && (
              <RetryPayment
                text={api.trans('blocks.epms_subscription_info.retry_payment')}
                className="retry-payment-line"
              />
            )}
          </Fragment>
        )}
      </div>
      <FooterInfo />
    </div>
  )
})
